import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {Quote, QuoteState} from '../../model/quote';
import {QuoteBarItem} from '../../model/quote-bar-item';

@Component({
    selector: 'app-list-quotes',
    templateUrl: './list-quotes.component.html',
    styleUrls: ['./list-quotes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListQuotesComponent {
    @Output()
    deleteQuote = new EventEmitter<Quote>();

    @Output()
    selectQuote = new EventEmitter<QuoteBarItem>();

    @Output()
    closeQuoteList = new EventEmitter();

    @Input()
    isPending;

    private _quotes: QuoteBarItem[] = [];

    @Input()
    set quotes(quotes: QuoteBarItem[]) {
        this._quotes = quotes.sort((bar1, bar2) => {
            if (bar1.quote.state !== bar2.quote.state) {
                if (bar1.quote.state === QuoteState.NEW) {
                    return -1;
                }
                if (bar2.quote.state === QuoteState.NEW) {
                    return 1;
                }
                if (bar1.quote.state === QuoteState.REQUESTED) {
                    return -1;
                }
                return 1;
            }
            if ((bar1.quote.state === QuoteState.REQUESTED || bar1.quote.state === QuoteState.ORDERED)
                && bar1.quote.request != null && bar2.quote.request != null) {
                return bar2.quote.request.requestDate.getTime() - bar1.quote.request.requestDate.getTime();
            }
            return bar2.quote.creationDate.getTime() - bar1.quote.creationDate.getTime();
        });
    }

    get quotes(): QuoteBarItem[] {
        return this._quotes;
    }

    onDeleteSubmit(quote: Quote) {
        this.deleteQuote.emit(quote);
    }

    onSelectQuote(quoteBarItem: QuoteBarItem) {
        this.selectQuote.emit(quoteBarItem);
    }

    closeQuotesList() {
        this.closeQuoteList.emit();
    }
}
